import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const Align = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    height={height}
    width={width}
    viewBox="0 0 24 24"
    data-test="align-icon"
    {...props}
  >
    <path
      fill={getColor(color, isColorInherited)}
      d="M6.6373 14.5125V17.376H19.6123V14.5125H6.6373ZM4.9873 14.4375C4.9873 13.5676 5.69246 12.8625 6.5623 12.8625H19.6873C20.5572 12.8625 21.2623 13.5676 21.2623 14.4375V17.451C21.2623 18.3208 20.5572 19.026 19.6873 19.026H6.5623C5.69246 19.026 4.9873 18.3208 4.9873 17.451V14.4375Z"
    />
    <path
      fill={getColor(color, isColorInherited)}
      d="M6.6373 6.62399V9.48749H13.4248V6.62399H6.6373ZM4.9873 6.54899C4.9873 5.67914 5.69246 4.97399 6.5623 4.97399H13.4998C14.3697 4.97399 15.0748 5.67914 15.0748 6.54899V9.56249C15.0748 10.4323 14.3697 11.1375 13.4998 11.1375H6.5623C5.69246 11.1375 4.9873 10.4323 4.9873 9.56249V6.54899Z"
    />
    <path
      fill={getColor(color, isColorInherited)}
      d="M3.5623 2.73749C4.01794 2.73749 4.3873 3.10685 4.3873 3.56249V20.4375C4.3873 20.8931 4.01794 21.2625 3.5623 21.2625C3.10667 21.2625 2.7373 20.8931 2.7373 20.4375V3.56249C2.7373 3.10685 3.10667 2.73749 3.5623 2.73749Z"
    />
  </SvgIcon>
);
